import { useCallback } from 'react'

import { useWorkflowSchema } from 'data/hooks/workflows/workflows'
import { convertOutputSchemaToOutputs } from 'features/workflows/OutputSchema/utils'

export function useAIPromptActionFinalSchema() {
    const { data: schema } = useWorkflowSchema()
    return useCallback(
        (config: WorkflowActionConfig): WorkflowSchemaNodeType | undefined => {
            const type = schema?.nodes.find(
                (t) => t.id === config.action_type
            ) as WorkflowSchemaActionType
            if (!type) return undefined

            const outputSchema = config.settings?.output_schema as WorkflowOutputSchema | undefined

            const stateItems = outputSchema
                ? convertOutputSchemaToOutputs(outputSchema)
                : [
                      {
                          id: 'response',
                          name: 'Response',
                          type: 'string' as const,
                      },
                  ]

            return {
                ...type,
                state: stateItems,
            }
        },
        [schema?.nodes]
    )
}
